import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { HomepageExperimentsQuery, HomepageExperimentsQueryVariables } from './api.graphql';
import { HomepageExperiments } from './api.graphql';

export async function getExperiments({ gql: { fetch } }: UtilityContext) {
	try {
		const { data } = await fetch<HomepageExperimentsQuery, HomepageExperimentsQueryVariables>({
			query: HomepageExperiments,
			rejectOnError: true,
		});

		return data.experiments;
	} catch (e) {
		return {
			// Fallback to control variation in case of error
			starfishHomepageToSapDraftV1: {
				type: 'experiment-service',
				experimentName: 'starfish_homepage_to_sap_draft_v1',
				variation: 'control',
				config: {},
				treated: true,
			},
		};
	}
}
